document.addEventListener("DOMContentLoaded", () => {
  waitForDiscountyWidget();

  function waitForDiscountyWidget() {
    const interval = setInterval(() => {
      const widget = document.querySelector(
        ".discounty-volume-discount-widget",
      );

      if (!widget) return;

      const rows = widget.querySelectorAll("tbody tr");

      if (!rows.length) return;

      clearInterval(interval);

      buildCustomVolumePricing(widget);
    }, 250);
  }

  function buildCustomVolumePricing(widget) {
    const wrapper = document.querySelector(".custom-staffels-wrapper");
    const defaultStaffel = parseInt(wrapper?.dataset.defaultStaffel) || null;

    const tiers = [];

    widget.querySelectorAll("tbody tr").forEach((row) => {
      const qtyElement = row.querySelector(
        ".discounty-volume-discount-widget__criteria",
      );

      const priceElement = row.querySelector(
        ".discounty-volume-discount-widget__discount",
      );

      if (!qtyElement || !priceElement) return;

      const qty = parseInt(qtyElement.textContent.replace("+", "").trim());

      const label = priceElement.textContent.trim();

      const price = parseFloat(
        label
          .replace("€", "")
          .replace(",", ".")
          .match(/[0-9.]+/)[0],
      );

      tiers.push({
        qty,
        price,
        label,
      });
    });

    if (!tiers.length) return;

    const basePrice = tiers[0].price;

    const container = document.createElement("div");

    container.className = "custom-volume-pricing";

    let html = `

            <div class="custom-volume-pricing__title">
                <div>Staffelprijzen bedrukkingen</div>
                <div>Excl. btw</div>
            </div>


            <div class="custom-volume-pricing__wrapper">
                <div class="custom-volume-pricing__header">
                    <div>Aantal</div>
                    <div>Je voordeel</div>
                    <div>Per stuk</div>
                </div>
                <div class="custom-volume-pricing__body">
        `;

    tiers.forEach((tier) => {
      let saving;

      if (tier.qty === 1) {
        saving = "Basisprijs";
      } else {
        const percent = Math.round((1 - tier.price / basePrice) * 100);

        saving = `Bespaar ${percent}%`;
      }

      html += `

                <div
                    class="custom-volume-pricing__row"
                    data-min-qty="${tier.qty}"
                >

                    <div class="custom-volume-pricing__qty">
                      ${tier.qty}+
                    </div>

                    <div class="custom-volume-pricing__saving">
                        ${saving}
                        ${tier.qty === defaultStaffel ? "<span>meest gekozen</span>" : ""}
                    </div>

                    <div class="custom-volume-pricing__price">
                         ${tier.label.split(" ")[0]}
                    </div>

                </div>

            `;
    });

    html += `

                </div>

            </div>

            <div class="custom-volume-pricing__note">
                <span class="custom-volume-pricing__dot"></span>
                Prijs per bedrukking, per positie.
            </div>

        `;

    container.innerHTML = html;

    if (wrapper) {
      wrapper.innerHTML = "";
      wrapper.appendChild(container);
    } else {
      widget.after(container);
    }

    widget.remove();

    if (defaultStaffel) {
      const qtyInput =
        document.querySelector(".quantity__input") ||
        document.querySelector('input[name="quantity"]') ||
        document.querySelector(".quantity input");

      if (qtyInput) {
        qtyInput.value = defaultStaffel;

        qtyInput.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );

        updateActiveTier(defaultStaffel);
      }
    } else {
      updateActiveTier();
    }

    document.addEventListener(
      "blur",
      function (event) {
        if (isQuantityInput(event.target)) {
          console.log("Quantity blur:", event.target.value);

          updateActiveTier(event.target.value);
        }
      },
      true,
    );

    document.addEventListener("click", function (event) {
      const row = event.target.closest(".custom-volume-pricing__row");

      if (!row) return;

      const qty = row.dataset.minQty;

      const qtyInput =
        document.querySelector(".quantity__input") ||
        document.querySelector('input[name="quantity"]') ||
        document.querySelector(".quantity input");

      if (!qtyInput) return;

      qtyInput.value = qty;

      // Zorg dat Shopify de wijziging ook ziet
      qtyInput.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );

      updateActiveTier(qty);
    });

    function isQuantityInput(input) {
      return (
        input.matches(".quantity__input") ||
        input.matches('input[name="quantity"]') ||
        input.matches(".quantity input")
      );
    }

    function getQuantityValue() {
      const input =
        document.querySelector(".quantity__input") ||
        document.querySelector('input[name="quantity"]') ||
        document.querySelector(".quantity input");

      return input ? input.value : 1;
    }

    function updateDisplayedPrice(row) {
      if (!row) return;

      const priceText = row
        .querySelector(".custom-volume-pricing__price")
        ?.textContent.trim();

      if (!priceText) return;

      const excl = parseFloat(
        priceText.replace("€", "").replace(",", ".").trim(),
      );

      if (isNaN(excl)) return;

      const incl = excl * 1.21;

      const exclElement = document.querySelector(
        ".product__price-wrapper .price__container .nf-excl-price",
      );

      console.log(exclElement);

      const inclElement = document.querySelector(
        ".product__price-wrapper .price__container .nf-incl-price",
      );

      const exclElements = document.querySelectorAll(".nf-excl-price");
      const inclElements = document.querySelectorAll(".nf-incl-price");

      exclElements.forEach((element) => {
        element.textContent = `€${excl.toFixed(2).replace(".", ",")}`;
      });

      inclElements.forEach((element) => {
        element.textContent = `€${incl.toFixed(2).replace(".", ",")}`;
      });
    }

    function updateActiveTier(value = null) {
      const qty = parseInt(value ?? getQuantityValue()) || 1;

      console.log("Active tier check:", qty);

      const rows = container.querySelectorAll(".custom-volume-pricing__row");

      rows.forEach((row) => {
        row.classList.remove("custom-volume-pricing__row--active");
      });

      let activeRow = rows[0];

      rows.forEach((row) => {
        const minQty = parseInt(row.dataset.minQty);

        if (qty >= minQty) {
          activeRow = row;
        }
      });

      if (activeRow) {
        activeRow.classList.add("custom-volume-pricing__row--active");
        updateDisplayedPrice(activeRow);
      }
    }
  }

  document.addEventListener("click", function (event) {
    const variant = event.target.closest(".size-variant");

    if (!variant) return;

    const priceWrapper = document.querySelector(".product_price-wrapper");

    if (priceWrapper) {
      priceWrapper.style.transition = "opacity 0.2s ease";
      priceWrapper.style.opacity = "0";
    }

    setTimeout(() => {
      const activeRow = document.querySelector(
        ".custom-volume-pricing__row--active",
      );

      if (activeRow) {
        activeRow.click();
      }

      setTimeout(() => {
        if (priceWrapper) {
          priceWrapper.style.opacity = "1";
        }
      }, 150);
    }, 500);
  });
});